import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    browserScale: 1.0
  },
  getters: {},
  mutations: {
    setBrowserScale(state, newVal) {
      state.browserScale = newVal
      // alert(newVal)
    }
  },
  actions: {},
  modules: {}
})
